// hooks/useAuth.ts
import { useAuthStore } from '../store/useAuthStore2';

export const useAuth = () => {
  const store = useAuthStore();
  return {
    ...store,
    isAuthenticated: !!store.accessToken,
  };
};
